export default "__VITE_ASSET__DNST3$s7__"